import { Card } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../locales/translations';
import CreditLiquidationFilterLoader from './parts/CreditLiquidationFilterLoader';
import CreditLiquidationDataLoader from './parts/CreditLiquidationDataLoader';
import { CreditLiquidationFilter } from './parts/CreditLiquidationFilter';
import CreditLiquidationTable from './parts/CreditLiquidationTable';

export default function CreditLiquidationInitial() {
  const { t } = useTranslation(TranslationsKeys.CREDIT_LIQUIDATION_INITIAL);
  return (
    <div className="mx-3">
      <Card className="p-4">
        <p className="mb-4 text-muted">{t('description')}</p>
        <CreditLiquidationFilterLoader>
          <CreditLiquidationDataLoader>
            <CreditLiquidationFilter />
            <CreditLiquidationTable />
          </CreditLiquidationDataLoader>
        </CreditLiquidationFilterLoader>
      </Card>
    </div>
  );
}
